import React from 'react'
import { connect } from 'react-redux'
import lisbonDataScienceHubLogo from '../../static/graphics/logos/logo-ldsh.svg'
import { confirmationDialog } from '../common/confirmation-dialog'
import TextAreaSubmit from '../common/text-area-submit'
import { createSuggestion } from '../../store/actions/suggestions'

export class AboutView extends React.Component {
    static propTypes = {
        // auth: PropTypes.object.isRequired,
    }

    onSuggestionTextClick = (text) => {
        confirmationDialog({
            title: 'Suggestion Box',
            text: 'Do you wish to send the message?',
            positiveText: 'Send',
            positiveColor: 'primary',
            negativeText: 'Cancel',
            negativeColor: 'secondary',
            positiveCallback: () => {
                this.props.createSuggestion(text)
            },
        })
    }

    render() {
        return (
            <>
                <div className="container">
                    <p className="font-weight-bold text-secondary">
                        Need help?
                    </p>
                    <p className="m-2">
                        If you experience any problem with the website, please{' '}
                        <a
                            href="mailto:joaosousa_gamboa@siemens.com;goncalo.carito@siemens.com?Subject=Problema%20com%20a%20plataforma%20Visão%202030"
                            target="_top">
                            contact us.
                        </a>
                    </p>

                    <p className="font-weight-bold text-secondary mt-4">
                        Help us make {process.env.REACT_APP_DISPLAY_SHORT_NAME}{' '}
                        better!
                    </p>

                    <TextAreaSubmit
                        text=""
                        maxLength="1000"
                        rows="8"
                        clearOnSubmit={true}
                        onSubmit={this.onSuggestionTextClick}
                        placeholder="Send us any suggestions you may have..."></TextAreaSubmit>
                </div>

                <div className="container text-center mt-4">
                    <img
                        alt="ldsh_logo"
                        src={lisbonDataScienceHubLogo}
                        width="350px"
                    />
                </div>
            </>
        )
        
    }
}

const mapStateToProps = (state) => ({
    //   auth: state.auth,
})

export default connect(mapStateToProps, { createSuggestion })(AboutView)
